import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import GlobalStateDataProvider from './context-api/data-provider/GlobalStateDataProvider';
import SignUpDataProvider from './context-api/data-provider/SignupDataProvider';
import AddressDataProvider from './context-api/data-provider/GoogleAddressDataProvider';
import FutureCustomerDataProvider from './context-api/data-provider/FutureCustomerDataProvider';
import OrderDataProvider from './context-api/data-provider/OrderDataProvider';
import UpdateOperationDataProvider from './context-api/data-provider/UpdateOperationDataProvider';
import '../src/styles/styles.css';
import ProductDataProvider from './context-api/data-provider/ProductDataProvider';
import OpenAiProvider from './context-api/data-provider/openAiDataProvider';
import RevenueSharingDataProvider from './context-api/data-provider/RevenueSharingDataProvider';
import MerchantDocDataProvider from './context-api/data-provider/MerchantDocDataProvider';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
    <GlobalStateDataProvider>
      <RevenueSharingDataProvider>
        <OpenAiProvider>
          <FutureCustomerDataProvider>
            <AddressDataProvider>
              <SignUpDataProvider>
                <OrderDataProvider>
                  <UpdateOperationDataProvider>
                    <ProductDataProvider>
                      <MerchantDocDataProvider>
                        <App />
                      </MerchantDocDataProvider>
                    </ProductDataProvider>
                  </UpdateOperationDataProvider>
                </OrderDataProvider>
              </SignUpDataProvider>
            </AddressDataProvider>
          </FutureCustomerDataProvider>
        </OpenAiProvider>
      </RevenueSharingDataProvider>
    </GlobalStateDataProvider>
  </BrowserRouter>
  // </React.StrictMode>
);

reportWebVitals();